/* screens/dev/UiKitParts2.jsx — витрина (часть 2): поля ввода, метрики, табы/якоря. */

import React from 'react';
import { AnchorNav, ScrollRow, Tabs } from '../../components/patterns/Tabs.jsx';
import { Checkbox, Field, Labeled, NativeSelect, NumberInput, PasswordInput, SearchInput, Segmented, StrengthMeter, TextInput, Textarea } from '../../components/ui/Field.jsx';
import { ExtraMetric, Metric, MiniBar, Stat, UsageBar } from '../../components/ui/Metric.jsx';
import { Select } from '../../components/ui/Select.jsx';
import { Switch } from '../../components/ui/Switch.jsx';
import { fmt } from '../../lib/format.js';
import { Num, NumScale } from '../../components/ui/Num.jsx';
import { UiKitSection as Section, UiKitStateBox as StateBox } from './UiKitParts1.jsx';

  const { useState } = React;

  const SELECT_OPTS = [
    { value: 'kg', label: 'Килограмм', hint: 'кг', group: 'Вес' },
    { value: 'g', label: 'Грамм', hint: 'г', group: 'Вес' },
    { value: 'l', label: 'Литр', hint: 'л', group: 'Объём' },
    { value: 'ml', label: 'Миллилитр', hint: 'мл', group: 'Объём' },
    { value: 'pc', label: 'Штука', hint: 'шт', group: 'Счёт' },
  ];

  /* ── Поля ввода ── */
  function FormsSection() {
    const [pwd, setPwd] = useState('Pa$$');
    const [num, setNum] = useState(250);
    const [sel, setSel] = useState('g');
    const [selMulti, setSelMulti] = useState(['g', 'ml']);
    const [selBulk, setSelBulk] = useState(['g']);
    const [nat, setNat] = useState('dish');
    const [seg, setSeg] = useState('compact');
    const [chk, setChk] = useState(true);
    const [sw, setSw] = useState(true);
    const [search, setSearch] = useState('');
    const [area, setArea] = useState('Краткое описание блюда…');
    return (
      <Section id="forms" title="Поля ввода" sub="Field-обёртка (label/hint/error). Checkbox — НАТИВНЫЙ. NumberInput с unit + stepper. Select с поиском (на мобиле — fullscreen-лист).">
        <div className="uikit-field-grid">
          <Field label="Название" hint="Как в меню"><TextInput defaultValue="Борщ московский" placeholder="Введите название" /></Field>
          <Field label="Артикул" error="Поле обязательно"><TextInput invalid placeholder="SKU-000" /></Field>
          <Field label="Только чтение"><TextInput readOnly defaultValue="Системное значение" /></Field>
          <Field label="Отключено"><TextInput disabled defaultValue="Недоступно" /></Field>
          <Field label="Пароль" hint="Минимум 8 символов">
            <PasswordInput value={pwd} onChange={(e) => setPwd(e.target.value)} />
            <div style={{ marginTop: 6 }}><StrengthMeter value={pwd} /></div>
          </Field>
          <Field label="Количество, выход"><NumberInput value={num} onChange={setNum} unit="г" step={10} min={0} /></Field>
          <Field label="Единица (Select + поиск)"><Select value={sel} onChange={setSel} options={SELECT_OPTS} placeholder="Выберите единицу" /></Field>
          <Field label="Мультивыбор (Select multiple, без каретки)"><Select multiple hideCaret value={selMulti} onChange={setSelMulti} options={SELECT_OPTS} placeholder="Выберите единицы" /></Field>
          <Field label="Мультивыбор с массовыми действиями (bulkActions)" hint="«Выбрать все» уважает поиск, «Инвертировать» — по всему списку"><Select multiple hideCaret searchable bulkActions value={selBulk} onChange={setSelBulk} options={SELECT_OPTS} placeholder="Выберите единицы" /></Field>
          <Field label="Тип (NativeSelect)"><NativeSelect value={nat} onChange={(e) => setNat(e.target.value)} options={[{ value: 'dish', label: 'Блюдо' }, { value: 'semi', label: 'Полуфабрикат' }]} /></Field>
          <Field label="Поиск с debounce"><SearchInput value={search} onChange={setSearch} onDebouncedChange={() => {}} placeholder="Найти сырьё…" /></Field>
          <Field label="Описание (авторост)"><Textarea value={area} onChange={(e) => setArea(e.target.value)} /></Field>
        </div>
        <div className="uikit-demo-row" style={{ marginTop: 'var(--space-16)' }}>
          <div className="uikit-demo-col"><div className="uikit-state-label">Segmented</div><div className="stack stack-6"><Segmented value={seg} onChange={setSeg} options={[{ value: 'compact', label: 'Компактно' }, { value: 'comfortable', label: 'Свободно' }]} /><Segmented disabled value="comfortable" onChange={() => {}} ariaLabel="Отключён" options={[{ value: 'compact', label: 'Компактно' }, { value: 'comfortable', label: 'Свободно' }]} /></div></div>
          <div className="uikit-demo-col"><div className="uikit-state-label">Checkbox (нативный)</div><div className="stack stack-6"><Checkbox label="Учитывать потери" checked={chk} onChange={(e) => setChk(e.target.checked)} /><Checkbox label="Промежуточное" indeterminate onChange={() => {}} /><Checkbox label="Отключено" disabled /></div></div>
          <div className="uikit-demo-col"><div className="uikit-state-label">Switch (тумблер)</div><div className="cluster cluster-12"><Switch checked={sw} onChange={setSw} ariaLabel="Демо-тумблер" /><Switch checked onChange={() => {}} disabled ariaLabel="Отключён (вкл)" /><Switch checked={false} onChange={() => {}} disabled ariaLabel="Отключён (выкл)" /></div></div>
          <div className="uikit-demo-col"><div className="uikit-state-label">Labeled (read-only)</div><div className="cluster cluster-12"><Labeled label="Выход" value="250 г" mono /><Labeled label="FC%" value="28,4 %" mono /></div></div>
        </div>
      </Section>
    );
  }

  /* ── Метрики ── */
  function MetricsSection() {
    return (
      <Section id="metrics" title="Метрики и индикаторы" sub="Stat (с дельтой), Metric (KPI-карточка), ExtraMetric (inline), MiniBar/UsageBar (квота, >80% меняет цвет).">
        <div className="uikit-field-grid">
          <StateBox label="Stat"><div className="cluster cluster-16"><Stat value={fmt.money(284500)} label="Выручка за месяц" delta={12} /><Stat value="28,4 %" label="Средний FC" delta={-3} /></div></StateBox>
          <StateBox label="Metric (KPI)"><div className="stack stack-12"><Metric icon="kitchen" value="142" label="ТТК в работе" tone="accent" /><Metric icon="alert-triangle" value="7" label="Без цены" tone="warn" /></div></StateBox>
          <StateBox label="ExtraMetric"><div className="cluster cluster-12"><ExtraMetric label="Ккал" value="320 ккал" /><ExtraMetric label="Выход" value="250 г" /><ExtraMetric label="Себест." value="142 ₽" /></div></StateBox>
          <StateBox label="UsageBar (квота)"><div className="stack stack-12"><UsageBar label="ТТК" used={142} limit={200} /><UsageBar label="Запросы к ассистенту" used={188} limit={200} /><UsageBar label="Хранилище, МБ" used={920} limit={1000} unit="" /></div></StateBox>
        </div>
        <div className="stack stack-12" style={{ marginTop: 16 }}>
          <div className="uikit-state-label">
            NumScale + Num — общий кегль чисел (размер задаёт самое длинное значение)
          </div>
          <div className="cluster cluster-16">
            <StateBox label="короткие значения">
              <NumScale className="cluster cluster-16">
                <Num className="ov-kpi__value">4 030</Num>
                <Num className="ov-kpi__value">2 600</Num>
                <Num className="ov-kpi__value">666,70 ₽</Num>
              </NumScale>
            </StateBox>
            <StateBox label="то же + одно длинное — мельчают ВСЕ, ряд ровный">
              <NumScale className="cluster cluster-16">
                <Num className="ov-kpi__value">4 030</Num>
                <Num className="ov-kpi__value">2 600</Num>
                <Num className="ov-kpi__value">12 686 805,97 ₽</Num>
              </NumScale>
            </StateBox>
          </div>
        </div>
      </Section>
    );
  }

  /* ── Табы и якоря ── */
  function TabsSection() {
    const [t1, setT1] = useState('all');
    const [t2, setT2] = useState('week');
    const [t3, setT3] = useState('a');
    const tabsItems = [
      { value: 'all', label: 'Все', count: 142 }, { value: 'dishes', label: 'Блюда', count: 86 },
      { value: 'semi', label: 'Полуфабрикаты', count: 38 }, { value: 'ingredients', label: 'Сырьё', count: 204 },
      { value: 'archived', label: 'Архив', count: 12 },
    ];
    return (
      <Section id="tabs" title="Табы и навигация по якорям" sub="Tabs: line / pills / segmented; при переполнении уходят в ScrollRow с edge-fade. AnchorNav — sticky навигация раздела.">
        <div className="stack stack-16">
          <div><div className="uikit-state-label">line (переполнение → ScrollRow)</div><Tabs items={tabsItems} value={t1} onChange={setT1} variant="line" /></div>
          <div><div className="uikit-state-label">pills</div><Tabs items={[{ value: 'week', label: 'Неделя' }, { value: 'month', label: 'Месяц' }, { value: 'quarter', label: 'Квартал' }, { value: 'year', label: 'Год' }]} value={t2} onChange={setT2} variant="pills" /></div>
          <div><div className="uikit-state-label">segmented</div><Tabs items={[{ value: 'a', label: 'Таблица', icon: 'reports' }, { value: 'b', label: 'Плитки', icon: 'grid' }]} value={t3} onChange={setT3} variant="segmented" /></div>
          <div><div className="uikit-state-label">AnchorNav (горизонтальный)</div><AnchorNav orientation="horizontal" items={[{ id: 'type', num: 1, label: 'Типографика' }, { id: 'buttons', num: 2, label: 'Кнопки' }, { id: 'forms', num: 3, label: 'Поля' }, { id: 'table', num: 4, label: 'Таблица' }]} /></div>
        </div>
      </Section>
    );
  }

export { FormsSection };
export { MetricsSection };
export { TabsSection };
